/**
 * Confirm the invoice's existing PaymentIntent from a deferred-mode Elements group.
 *
 * Elements lists only the methods we enable (`paymentMethodTypes`), but chekkit-rep
 * creates PaymentIntents with automatic payment methods, and Stripe rejects
 * `confirmPayment({ elements })` when the two are configured differently. Creating the
 * PaymentMethod first and confirming with its id avoids that check; Stripe.js still
 * handles 3D Secure and other next actions.
 *
 * Call `elements.submit()` before this.
 */
export async function confirmDeferredPayment({
	stripe,
	elements,
	clientSecret,
	billingDetails,
}) {
	const { error: createError, paymentMethod } =
		await stripe.createPaymentMethod({
			elements,
			...(billingDetails ? { params: { billing_details: billingDetails } } : {}),
		});

	if (createError) {
		return { error: createError };
	}

	return stripe.confirmPayment({
		clientSecret,
		confirmParams: {
			payment_method: paymentMethod.id,
			return_url: window.location.href,
		},
		redirect: 'if_required',
	});
}
